import React from 'react';
import ReactDOM from 'react-dom/client';


import App from './App';

import reportWebVitals from './reportWebVitals';
//css
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';


window.authApi = "https://localhost:7256/api/";
window.reCaptchaClientKey = "6LehuJkkAAAAAK33brLbeeu8mBgg3Zev3Pi3oRs3";
window.phpapi = "http://localhost/phpapi/index.php/api/";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <App/>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
